import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";

import { IBillDetail } from "../../BillTypes";
import { useBillRechargeLogModel } from "../billRechargeLogModel";
import useGlobalModel from "@/model/globalModel";
import { billStatusRender } from "@/types/FmsRender";
import { SnippetsOutlined } from "@ant-design/icons";
import { creditFlagRender, momentFormat, timeShift } from "@/utils/utils";
import { getBaseImgLookUrl } from "@/utils/constants";
import { httpRequest } from "@/utils/HttpRequest";
import { convertRes2Blob } from "@/utils/exportFile";
import PreviewModal from "@/components/YhPreview/index";
import YhTootip from "@/components/YhTootip";
import moment from "moment";


export function BillDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys,searchParam,setSelectedData
    } = useBillRechargeLogModel();

    const { user: { shopCode } } = useGlobalModel()
    // 预览附件内容
    const [previewInfo, setPreviewInfo] = useState<any>({
        visible: false,
        md5: "",
        fileName: "",
        filePath: "",
        fileType: ""
    })

    // 打开附件弹框
    const onPreview = async (item: any) => {
        console.log("附件预览", item);
        let fileMd5 = item?.md5
        let fileName = item?.fileName as string
        let fileType = fileName?.substring(fileName.lastIndexOf(".") + 1) ?? 'png'
        let filePath = `${getBaseImgLookUrl(fileMd5 as string)}`
        if (fileType === 'docx') {
            const file = await httpRequest
                .postFile(filePath);
            return convertRes2Blob(file);
        }
        setPreviewInfo({
            visible: true,
            md5: fileMd5 as string,
            fileName,
            filePath,
            fileType
        })
    }

    // 关闭附件弹框
    const onCancel = () => {
        setPreviewInfo({ visible: false, md5: "", fileName: "", filePath: "", fileType: "" })
    }
    const columns: ColumnsType<any> = [
        {
            align: "center",
            width: 60,
            ellipsis: true,
            title: '序号',
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            title: '分支',
            dataIndex: 'branch',
            width: 80,
        },        
        {
            align: "center",
            title: searchParam.supplier === "1"?'供应商名称':'客户名称',
            dataIndex: 'partnerName',
            width: 260,
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            align: "center",
            title: '账户名称',
            dataIndex: 'accountName',
            width: 600,
            render: (t, r) => r?.md5 === null
                ? <span>{t}</span>
                : <span style={{ position: "relative" }}>
                    {t}
                    <i style={{ position: "absolute", right: "-15px", top: "-3px", color: "#5200ff" }} onClick={() => onPreview(r)}>
                        <SnippetsOutlined />
                    </i>
                </span>
        },
        {
            align: "center",
            title: '授信类型',
            dataIndex: 'creditFlag',
            width: 80,
            render: (v) => creditFlagRender(v)
        },
        {
            align: "center",
            title: '从属机构',
            dataIndex: 'orgName',
            width: 150,
        },
        {
            align: "center",
            title: '账户实体',
            width: 200,
            dataIndex: 'beName',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            align: "center",
            title: '原剩余金额',
            width: 90,
            dataIndex: 'remainingAmount',
        },
        {
            align: "center",
            title: '充值金额',
            width: 80,
            dataIndex: 'rechargeAmount',
        },
        {
            align: "center",
            title: '支付方式',
            width: 110,
            dataIndex: 'payMethodName',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            align: "center",
            title: '审核状态',
            dataIndex: 'status',
            width: 130,
            render: (v, r) => v === 1
                ? '审核通过(已调整)'
                : v === 3
                    ? '撤回'
                    : v === 8
                        ? '审核驳回'
                        : v === 9
                            ? '失败'
                            : '待审核'
        },
        {
            align: "center",
            title: '业务员',
            width: 90,
            dataIndex: 'createUser',
        },
        {
            align: "center",
            title: '收款人',
            width: 80,
            dataIndex: 'operator',
        },
        {
            align: "center",
            title: '充值日期',
            width: 180,
            dataIndex: 'createTime',
        },
        {
            align: "center",
            title: '审核时间',
            dataIndex: 'approvalTime',
            width: 180,
            render: (text) => momentFormat(text)??''
        },
        {
            align: "center",
            title: '审核员',
            width: 100,
            dataIndex: 'approver',
        },
        {
            align: "center",
            title: '备注',
            width: 120,
            dataIndex: 'note',
            render: (text: string) => <YhTootip text={text} />,
        },
    ];


    return (
        <>
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IBillDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                    selectedRows.length > 0 ? setSelectedData(selectedRows[0]) : setSelectedData(undefined)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
        onRow={record => {
            return {
                onClick: event => {
                    if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                        setSelectedRowKeys([]);
                        setSelectedData(undefined)
                    } else {
                        setSelectedRowKeys([record.key]);
                        setSelectedData(record)
                    }
                },
            };
        }}
        />
        {
            previewInfo.visible && <PreviewModal
                visible={previewInfo.visible}
                onCancel={onCancel}
                md5Id={previewInfo.md5}
                fileName={previewInfo.fileName}
                filePath={previewInfo.filePath}
                fileType={previewInfo.fileType}
            />
            }
        </>
    )
}
